const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FeaturedProductsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  setupCarousel () {
    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        dragStartThreshold: 10,
        drag: true,
        slides: {
          perView: 1.5,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.25,
              spacing: 0,
            },
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 3.25,
              spacing: 0,
            },
          },
          '(min-width: 1280px)': {
            slides: {
              perView: 4,
              spacing: 0,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    this.els?.wrapper?.element.setAttribute('data-initialised', 'true')

    return slider
  }
}

if (!customElements.get('featured-products-carousel')) {
  customElements.define('featured-products-carousel', FeaturedProductsCarousel)
}
